import React from 'react';

function AddIcon() {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.5 3.33366C8.8731 3.33366 7.37343 3.46783 6.16971 3.6268C5.0864 3.76988 4.26951 4.58676 4.12644 5.67008C3.96746 6.87379 3.83329 8.37347 3.83329 10.0003C3.83329 11.6272 3.96746 13.1269 4.12644 14.3306C4.26951 15.4139 5.0864 16.2308 6.16971 16.3738C7.37343 16.5328 8.8731 16.667 10.5 16.667C12.1268 16.667 13.6265 16.5328 14.8302 16.3738C15.9135 16.2308 16.7304 15.4139 16.8735 14.3306C17.0325 13.1269 17.1666 11.6272 17.1666 10.0003C17.1666 8.37347 17.0325 6.87379 16.8735 5.67008C16.7304 4.58676 15.9135 3.76988 14.8302 3.6268C13.6265 3.46783 12.1268 3.33366 10.5 3.33366ZM5.95149 1.97449C4.12083 2.21626 2.7159 3.62119 2.47412 5.45186C2.3079 6.71039 2.16663 8.28472 2.16663 10.0003C2.16663 11.7159 2.3079 13.2903 2.47412 14.5488C2.7159 16.3795 4.12083 17.7844 5.95149 18.0262C7.21003 18.1924 8.78435 18.3337 10.5 18.3337C12.2156 18.3337 13.7899 18.1924 15.0484 18.0262C16.8791 17.7844 18.284 16.3795 18.5258 14.5488C18.692 13.2903 18.8333 11.7159 18.8333 10.0003C18.8333 8.28472 18.692 6.71039 18.5258 5.45186C18.284 3.6212 16.8791 2.21626 15.0484 1.97449C13.7899 1.80827 12.2156 1.66699 10.5 1.66699C8.78435 1.66699 7.21003 1.80827 5.95149 1.97449Z'
        fill='#27323C'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.5 14.1663C10.9603 14.1663 11.3334 13.7932 11.3334 13.333V10.833H13.8334C14.2936 10.833 14.6667 10.4599 14.6667 9.99967C14.6667 9.53944 14.2936 9.16634 13.8334 9.16634H11.3334V6.66634C11.3334 6.2061 10.9603 5.83301 10.5 5.83301C10.0398 5.83301 9.66671 6.2061 9.66671 6.66634V9.16634H7.16671C6.70647 9.16634 6.33337 9.53944 6.33337 9.99967C6.33337 10.4599 6.70647 10.833 7.16671 10.833H9.66671V13.333C9.66671 13.7932 10.0398 14.1663 10.5 14.1663Z'
        fill='#27323C'
      />
    </svg>
  );
}

export default AddIcon;
